// jQuery(document).ready(function($) {


  
  $(document).on("click", function(event) {

    
//     if (!$(".custom_filter").is(event.target) && !$(".custom_filter").has(event.target).length) {
//       $(".preview_box .row-flex").removeClass("custom_tab");
//       $(".custom_filter .dropdown_title").removeClass("custom_dropdown_title");
//     }
//   });  
//   $(".custom_filter").click(function(event) {
//     event.stopPropagation();
//     $(".preview_box .row-flex").addClass("custom_tab");
//     $(".custom_filter .dropdown_title").addClass("custom_dropdown_title");
//   });
  $('.dropdown_title').click(function (e) {
    e.stopPropagation(); // Prevent the click event from reaching the document
    $('.row-flex').removeClass('d-none');
});

$(document).click(function (e) {
    if (!$(e.target).closest('.row-flex').length && !$(e.target).hasClass('dropdown_title')) {
        $('.row-flex').addClass('d-none  test');
    }
});

  });










